import React from 'react';
import { FeatureItem, Section, SectionHeader, useScrollReveal } from '../ui';

// eslint-disable-next-line import/prefer-default-export
export function HowItWorks() {
  const revealRef = useScrollReveal();
  const steps = [
    {
      icon: (
        <img
          src="/assets/icons/icon_post_role.webp"
          alt="Post Your Role"
          width={256}
          height={256}
          className="w-full h-full p-2 object-contain"
          loading="lazy"
        />
      ),
      title: '1. Post Your Role',
      description: 'Define requirements, hiring timeline, and your recruiter fee & guarantee.',
    },
    {
      icon: (
        <img
          src="/assets/icons/icon_agencies_deliver.webp"
          alt="Agencies Deliver"
          width={256}
          height={256}
          className="w-full h-full p-2 object-contain"
          loading="lazy"
        />
      ),
      title: '2. Agencies Deliver',
      description: 'Start receiving qualified candidates from agencies.',
    },
    {
      icon: (
        <img
          src="/assets/icons/icon_review_compare.webp"
          alt="Review & Compare"
          width={256}
          height={256}
          className="w-full h-full p-2 object-contain"
          loading="lazy"
        />
      ),
      title: '3. Review & Compare',
      description:
        'Review submissions, accept or decline, schedule interviews, and manage feedback.',
    },
    {
      icon: (
        <img
          src="/assets/icons/icon_hire_close.webp"
          alt="Hire & Pay on Success"
          width={256}
          height={256}
          className="w-full h-full p-2 object-contain"
          loading="lazy"
        />
      ),
      title: '4. Hire & Pay on Success',
      description:
        'Select the best candidate, complete references/background checks, sign an offer, and pay out the agency only after a successful hire — all in one place.',
    },
  ];

  return (
    <Section variant="default" className="text-center md:text-left" id="how-it-works">
      <SectionHeader title="How It Works" />
      <div
        ref={revealRef}
        className="max-w-6xl mx-auto px-4 grid md:grid-cols-4 gap-8 mb-16 relative"
      >
        {steps.map(step => (
          <div key={step.title} className="scroll-reveal">
            <FeatureItem
              icon={step.icon}
              title={step.title}
              description={step.description}
              layout="vertical"
              titleColor="tertiary"
              titleFontSize="2xl"
              iconSize="w-32 h-32 mb-8"
              removeIconBackground
            />
          </div>
        ))}
      </div>
      <div className="text-center">
        <p className="text-lg font-medium text-slate-600">
          No upfront fees <span className="text-slate-400 mx-2">•</span> No exclusivity traps{' '}
          <span className="text-slate-400 mx-2">•</span> No resume flooding or spam
        </p>
      </div>
    </Section>
  );
}
